import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { LSRW } from '../../utils/const';
import { tagEvent } from '../../utils/tagManager';
import {
	fetchAttempt,
	setShowTestInstr,
} from '../../redux/myCourse/myCourse.actions';
import {
	startAttempt,
	toggleMicPermission,
} from '../../redux/testPage/testPage.actions';
import Modal from 'react-bootstrap/Modal';
import { setSpeechStatus } from '../../redux/utilities/utils.actions';
import { recordAudio, sleep, isIos } from '../../utils/commonFunctions';
import UserTypes from '../../utils/userTypes';
import Config from '../../config/Config';
import Loader from '../../utils/Loader';
import { activateProctor, stopProctor, checkProctorStatus } from '../../utils/supervisor';
import jwt from 'jsonwebtoken'


const TestInstruction = ({
	instrDetails,
	fetchAttempt,
	startAttempt,
	//courseId,
	toggleMicPermission,
	showTestInstr,
	setShowTestInstr,
	showReview,
	hideSpeakTest,
	userType,
	product_id,
	product_name,
	userId,
	course_name,
}) => {
	const {
		domain,
		domains,
		hideStart,
		attemptRemaning,
		elementId,
		elementType,
		continueAttemptId,
		unitName,
		courseId,
		totalQuestion,
		elementName,
		reviewAttemptId,
		previewMode,
	} = instrDetails;

	var domainList = '';
	if (!!domain || !!domains) {
		domainList = domain.split('|').map(function (key) {
			return (
				<li key={key}>
					<img src={Config.ASSETSPATH + 'img/' + LSRW[key] + '.png'} alt="" />
				</li>
			);
		});
	}
	const [isSpeechAvail, setIsSpeechAvail] = useState(false);
	useEffect(() => {
		setIsSpeechAvail(false);
		domains.forEach((domain) => {
			if (domain === 'Speaking') {
				setIsSpeechAvail(true);
			}
		});
	}, [domains]);

	let audio = {};
	const isMounted = useRef(true);

	const retryRecording = () => {
		if (Object.keys(audio).length > 0) {
			audio.pause();
		}
		document.getElementById('recordFail').style.display = 'block';
		document.getElementById('beforeStart').style.display = 'block';
		document.getElementById('afterStart').style.display = 'none';
	};

	const handleClickAction = (event) => {
		event.currentTarget.disabled = true;
		Loader.show()
		event.stopPropagation()
	}

	const handleAction = async () => {
		isMounted.current = true;
		const recorder = await recordAudio();

		recorder.start();
		document.getElementById('beforeStart').style.display = 'none';
		document.getElementById('whileRecording').style.display = 'block';
		document.getElementById('recordFail').style.display = 'none';
		await sleep(6000);
		audio = await recorder.stop();
		if (isMounted.current) {
			document.getElementById('whileRecording').style.display = 'none';
			document.getElementById('afterStart').style.display = 'block';
			if (isIos()) document.getElementById('audioTestID').src = audio.audioUrl;
			else audio.play();
		}
	};

	const setSpeechActive = () => {
		toggleMicPermission(true);
		//setSpeechStatus()
		document.getElementById('recordSuccess').style.display = 'block';
		document.getElementById('afterStart').style.display = 'none';
		if (Object.keys(audio).length > 0) audio.pause();
	};

	const RPstart = () => {
		const userOrgID = localStorage.getItem('orgID');
		var eventDetails = '';
		if(userOrgID == 5192)
		{
			eventDetails = "ADDA247 FY25";
		} else if(userOrgID == 5689)
		{
			eventDetails = "ADDA247 FY26";
		}else if(userOrgID == 4973)
		{
			eventDetails = "HPCL - Batch 1";
		} else if(userOrgID == 5001)
		{
			eventDetails = "HPCL - Batch 2";
		} else if(userOrgID == 5008)
		{
			eventDetails = "HPCL - Batch 3";
		} else if(userOrgID == 5011)
		{
			eventDetails = "HPCL - Batch 4";
		} else if(userOrgID == 5012)
		{
			eventDetails = "HPCL - Batch 5";
		} else if(userOrgID == 5024)
		{
			eventDetails = "HPCL - Batch 6";
		} else if(userOrgID == 5036)
		{
			eventDetails = "HPCL - Batch 7";
		} else if(userOrgID == 5059)
		{
			eventDetails = "HPCL - Batch 8";
		} else if(userOrgID == 5060)
		{
			eventDetails = "HPCL - Batch 9";
		} else if(userOrgID == 5084)
		{
			eventDetails = "HPCL - Batch 10";
		} else if(userOrgID == 5089)
		{
			eventDetails = "HPCL - Batch 11";
		} else if(userOrgID == 5092)
		{
			eventDetails = "HPCL - Batch 12";
		} else if(userOrgID == 5093)
		{
			eventDetails = "HPCL - Batch 13";
		} else if(userOrgID == 5096)
		{
			eventDetails = "HPCL - Batch 14";
		} else if(userOrgID == 5113)
		{
			eventDetails = "HPCL - Batch 15";
		} else if(userOrgID == 5120)
		{
			eventDetails = "HPCL - Batch 16";
		} else if(userOrgID == 5121)
		{
			eventDetails = "HPCL - Batch 17";
		} else if(userOrgID == 5125)
		{
			eventDetails = "HPCL - Batch 18";
		} else if(userOrgID == 5181)
		{
			eventDetails = "HPCL - Batch 19";
		} else if(userOrgID == 5182)
		{
			eventDetails = "HPCL - Batch 20";
		} else if(userOrgID == 5183)
		{
			eventDetails = "HPCL - Batch 21";
		}  else if(userOrgID == 5193)
		{
			eventDetails = "HPCL - Batch 22";
		} else if(userOrgID == 5665)
		{
			eventDetails = "HURON EURASIA INDIA PRIVATE LIMITED FY26";
		} else if(userOrgID == 5617)
		{
			eventDetails = "Tag India Private Limited FY26";
		} else if(userOrgID == 6135)
		{
			eventDetails = "Ford Motor Private Limited FY26";
		}else if(userOrgID == 6137)
		{
			eventDetails = "Tag India Private Limited Batch 2 - FY26";
		}else if(userOrgID == 6168)
		{
			eventDetails = "FCMA CGM Global Business Services Batch 2 FY26";

		}



		if(elementId == 38801 || elementId==46077 || elementId==46338) {
		//proctoring API call set JWT token
		let jwtpayload = {
        "organisationId" : "78e6a175-45ad-41b3-bdc6-0e84092cca95",
        "sourceEventId" : eventDetails,
  		"eventName" : eventDetails,
  		"candidateName" : localStorage.getItem('loginId'),
  		"candidateId" : localStorage.getItem('loginId')+"-"+courseId+"-"+elementId,
  		"examDurationInMins" : 60,
        "iat": 100000, // iat = ~~(Date.now() / 1000) in seconds since UNIX epoch 
        "exp": Math.floor(Date.now() / 1000) + (60 * 60) // expires after 12 hours,
      }
      const header = {
      alg: 'HS256',
      typ: 'JWT'
      };
      const secret = 'cb6f3f6cb5e0413c953e2da01d91ad27';
      const jwtToken = jwt.sign(jwtpayload, secret);
      localStorage.setItem('RPToken', jwtToken);

			if (!!jwtToken) {
				let getProcSta = checkProctorStatus()
				console.log('checkProctorStatus ', getProcSta)
				if(!getProcSta) {
					activateProctor(jwtToken)
				}
			}
		} else if(elementId == 44468 || elementId == 46458) { //customized RP only Fleet management users at the cert test
		  eventDetails = "Fleet Management Training Institute FY26";
		 /* alert("coming here")*/
		let jwtpayload = {
			"organisationId" : "78e6a175-45ad-41b3-bdc6-0e84092cca95",
			"sourceEventId" : eventDetails,
			"eventName" : eventDetails,
			"candidateName" : localStorage.getItem('loginId'),
			"candidateId" : localStorage.getItem('loginId')+"-"+courseId+"-"+elementId,
			"examDurationInMins" : 60,
			"iat": 100000, // iat = ~~(Date.now() / 1000) in seconds since UNIX epoch 
			"exp": Math.floor(Date.now() / 1000) + (60 * 60) // expires after 12 hours,
		}
	      const header = {
		      alg: 'HS256',
		      typ: 'JWT'
	      };
	      const secret = 'cb6f3f6cb5e0413c953e2da01d91ad27';
	      const jwtToken = jwt.sign(jwtpayload, secret);
	      localStorage.setItem('RPToken', jwtToken);

					if (!!jwtToken) {
						let getProcSta = checkProctorStatus()
						console.log('checkProctorStatus ', getProcSta)
						if(!getProcSta) {
							activateProctor(jwtToken)
						}
					}
			}

	};


	const startTestTag = () => {
		if (previewMode) {
			localStorage.setItem('previewWebisodeStart', new Date());
			tagEvent({
				event: 'start_course_preview',
				user_id: userId,
				course_id: courseId,
				grant_name: course_name,
				product_id,
				product_name,
				platform: 'web',
			});
		}
	};

	return (
		<Modal
			show={showTestInstr}
			size="lg"
			style={{ minWidth: '300px' }}
			onHide={() => setShowTestInstr(false)}
			backdrop="static"
			keyboard={false}
			id="TestInstruction"
			className={
				(userType === UserTypes.Parent || userType === UserTypes.Junior) &&
					elementType === 'S'
					? 'TestInstruction-w500'
					: ''
			}
		>
			<Modal.Header closeButton>
				<h4 className="modal-title">
					{/*{unitName} &rarr;*/} {elementName}
				</h4>
			</Modal.Header>
			<Modal.Body>
				<div className="row">
					{userType === UserTypes.Parent || userType === UserTypes.Junior ? (
						<>
							{elementType === 'S' && (
								<img
									src={Config.ASSETSPATH + 'img/grandtestcore.png'}
									className="grandtestcore-icon"
									alt=""
								/>
							)}
							<div className="instruction_popup_new_style col-lg-12 col-xs-12 ">
								<h6>
									{elementType === 'S'
										? `You can only do this test once. Make sure that you're ready to finish the test in one sitting of 25 minutes. All the best!`
										: `This practice test is the exact same format as the final STEPathon Junior test. This is intended as a practice to understand what kind of questions you will get.`}
								</h6>
							</div>
							{elementType === 'S' ? (
								<div className="col-lg-12 col-xs-12 instruction_popup_new_style text-center">
									<h6 className="new_style_label mar-no">Total Questions</h6>
									<strong className="new_style_value">{totalQuestion}</strong>
								</div>
							) : (
								<div className="col-lg-6 col-xs-12 instruction_popup_new_style">
									<h6>Practice Questions:</h6> <b>{totalQuestion}</b>
								</div>
							)}{' '}
						</>
					) : (
						<>
							{elementType === 'S' && (
								<img
									src={Config.ASSETSPATH + 'img/grandtestcore.png'}
									className="grandtestcore col-lg-6 col-xs-12"
									alt=""
								/>
							)}
							<div className="flex flex-row">
								<div className="instruction_popup_new_style">
									<div>
										<h6>Skills Measured:</h6>
										<ul className="popup-icons">{domainList}</ul>
									</div>
								</div>

								<div className=" instruction_popup_new_style">
									<h6>{elementType === 'S' ? 'Questions:' : 'Practice Questions:'}</h6>
									<b>{totalQuestion}</b>
								</div>
							</div>
						</>
					)}
					<div className="click-button col-lg-12 col-xs-12">
						{!!reviewAttemptId &&
							localStorage.getItem('active_course_id') !== '428' &&
							Object.keys(reviewAttemptId).length > 0 && (
								<button
									aria-label="Review"
									type="button"
									className="btn btn-primary btn-popup-review mar-auto"
									onClick={(e) => {
										handleClickAction(e);
										fetchAttempt(reviewAttemptId[0], true);
									}}
								>
									Review Answer
								</button>
							)}
						<div
							className={`d-flex ${userType === UserTypes.Parent || userType === UserTypes.Junior
								? 'justify-content-center'
								: 'justify-content-end'
								} flex-grow-1`}
						>
							{!(!!attemptRemaning && !!hideStart) && (
								<button
									aria-label="Start"
									className="btn btn-primary btn-popup-start "
									onClick={(e) => {
										handleClickAction(e);
										startTestTag();
										startAttempt(courseId, elementId);
										RPstart();
									}}
									data-dismiss="modal"
								>
									Start
								</button>
							)}
							{!!continueAttemptId && (
								<button
									aria-label="Continue"
									className="btn btn-primary btn-popup-start "
									onClick={(e) => {
										handleClickAction(e);
										startTestTag();
										fetchAttempt(continueAttemptId);
										RPstart();
									}}
									data-dismiss="modal"
								>
									Continue
								</button>
							)}
						</div>
					</div>
				</div>
				{!hideSpeakTest && isSpeechAvail && (
					<div className="modal-footer test_mic_section">
						<div>
							<h5>
								On a new device? Follow instructions to test your microphone and
								speakers.
							</h5>
							<div id="beforeStart">
								<p>
									Please make sure your microphone is plugged in and allow your broswer
									to access your microphone and camera when prompted. <br /> Then, click
									start and speak few words.
								</p>

								<button
									aria-label="start"
									id="testMic"
									className="btn btn-sm btn-info go-next"
									onClick={(e) => {
										handleClickAction(e);
										handleAction()
									}}
								>
									Start
								</button>
							</div>

							<div style={{ display: 'none' }} id="whileRecording">
								<img
									src="https://img.icons8.com/ios/100/000000/listening--v2.png"
									alt="listening"
								/>
								<h6>
									<span className="test_message">Listening for audio</span>
									<div className="spinner">
										<div className="bounce1"></div>
										<div className="bounce2"></div>
										<div className="bounce3"></div>
									</div>
								</h6>
							</div>

							<div style={{ display: 'none' }} id="afterStart">
								<p>
									If you could hear your recorded audio please select 'Yes'. Else select
									'No' to try again
								</p>
								{isIos() && (
									<audio controls className="block-center">
										<source src="" type="audio/mpeg" id="audioTestID" />
										Your browser does not support the audio element.
									</audio>
								)}
								<button
									aria-label="yes"
									style={{ margin: '10px' }}
									type="button"
									onClick={(e) => {
										handleClickAction(e);
										setSpeechActive()
									}}
									className="btn btn-sm btn-success"
								>
									<i className="fa fa-check-circle"></i> YES
								</button>
								<button
									aria-label="no"
									style={{ margin: '10px' }}
									onClick={(e) => {
										handleClickAction(e);
										retryRecording()
									}}
									className="btn btn-sm btn-danger"
								>
									<i className="fa fa-times-circle"></i> NO
								</button>
							</div>

							<div style={{ display: 'none' }} id="recordSuccess">
								<p className="testing_mic_success">
									Awesome! Your speakers and microphones are set for your learning
									experience.
								</p>
							</div>
							<h6
								style={{ display: ' none' }}
								id="recordFail"
								className="testing_mic_failed"
							>
								If you are facing issues even with your microphone is plugged in please
								follow our
								<a
									href="http://support.steptest.in/support/solutions/articles/17000053626-speech-is-not-working-on-the-web"
									rel="noopener noreferrer"
									target="_blank"
									className="divAsAnchor"
								>
									guidelines
								</a>
								to troubleshoot.
							</h6>
						</div>
					</div>
				)}
			</Modal.Body>
		</Modal>
	);
};

const mapStateToProps = (state) => {
	const { coursedetails: { course_name } = {} } = state.rootReducer.myCourse;
	const { userId } = state.rootReducer.loginDetails;
	const {
		productData: { product_id, product_name } = {},
	} = state.rootReducer.buyCourse;
	return {
		instrDetails: state.rootReducer.myCourse,
		showTestInstr: state.rootReducer.myCourse.showTestInstr,
		showReview: state.rootReducer.testPageDetails.showReview,
		userType: state.rootReducer.loginDetails.userType,
		product_id,

		product_name,
		course_name,
		userId,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchAttempt: (attemptId, review = false) =>
			dispatch(fetchAttempt({ attemptId, review })),
		startAttempt: (courseId, elementId) =>
			dispatch(startAttempt({ courseId, elementId })),
		setSpeechStatus: () => dispatch(setSpeechStatus()),
		toggleMicPermission: (val) => dispatch(toggleMicPermission(val)),
		setShowTestInstr: (val) => dispatch(setShowTestInstr(val)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(TestInstruction);
